import { checkTrackingConversion } from './helpers/util';
import { pushGtagScripts } from './helpers/gtag';

// Sellers enter the Conversion ID with or without the "AW-" prefix.
function normalizeConversionId(id) {
  return String(id || '').trim().replace(/^AW-/i, '');
}

/**
 * @param {object} [conversion] - { transaction_id, order_number, value, currency } of a placed order. Only pages
 *   that pass it (the success page) report a Google Ads conversion; the others only load the tag.
 */
export async function handleGoogleAdsTracking(trackingGA, scripts, globalConversionSetting, conversionScope, conversion) {
  for (const ga of trackingGA) {
    const conversionId = normalizeConversionId(ga.pixelId);
    if (!conversionId) continue;

    const shouldProcess = await checkTrackingConversion(
      ga,
      `pixelsGoogleAds_${ga.pixelId}`,
      globalConversionSetting,
      conversionScope
    );
    if (!shouldProcess) continue;

    pushGtagScripts(scripts, `AW-${conversionId}`);

    // name holds the Conversion Label; it defaults to the Conversion ID until the seller sets a label.
    const label = String(ga.name || '').trim();
    if (conversion && conversion.transaction_id && label && normalizeConversionId(label) !== conversionId) {
      const params = JSON.stringify({
        send_to: `AW-${conversionId}/${label}`,
        // Enhanced Conversions match the server-side upload to this conversion by order number.
        transaction_id: String(ga.enhancedConversions && conversion.order_number ? conversion.order_number : conversion.transaction_id),
        value: Number(conversion.value) || 0,
        currency: conversion.currency || 'IDR'
      }).replace(/</g, '\\u003c');

      scripts.push({
        script: `<script>gtag('event', 'conversion', ${params});</script>`,
        name: "GTA",
        type: "GTA"
      });
    }
  }
}
